import PageHeader from './PageHeader';

function NotFoundPage() {
  return (
    <div className="card">
      <PageHeader title="Sayfa bulunamadi" description="Bu ekran icin taslak hazir degil." />
      <p className="muted">Sol menuden baska bir bolum secin.</p>
    </div>
  );
}

export default NotFoundPage;
